import React from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { Formik } from 'formik'
import * as yup from 'yup'
import PropTypes from 'prop-types'
import moment from 'moment'

import { Paragraph, Button } from '../../styles/generics'
import { InputField } from '../../styles/forms'

const validations = yup.object().shape({
  email: yup
    .string()
    .email('Email no válido')
    .required('Campo requerido'),
  phone: yup.string().required('Campo requerido')
})

const FormConfirmAppointment = props => (
  <Container>
    <Title>Información del turno</Title>
    <Details>
      <Span>{`${props.clinic.nombre}:`}</Span>
      <Value>{props.clinic.direccion}</Value>
      {props.specialty && (
        <React.Fragment>
          <Span>Especialidad:</Span>
          <Value>{props.specialty.nombre}</Value>
        </React.Fragment>
      )}
      {props.professional && (
        <React.Fragment>
          <Span>Profesional:</Span>
          <Value>{props.professional.nombreProfesional}</Value>
        </React.Fragment>
      )}
      {props.schedule && (
        <React.Fragment>
          <Span>Fecha y hora del turno:</Span>
          <Value>{moment(props.schedule).format('DD/MM/YYYY - HH:mm')}hs</Value>
        </React.Fragment>
      )}
      <Span>Nombre del paciente:</Span>
      <Value>{props.patient.nombreApellido}</Value>
      <Span>Cobertura médica:</Span>
      <Value>{props.patient.coberturaMedica}</Value>
      <Span>Plan/Línea/Cartilla:</Span>
      <Value>{props.patient.planLineaCartilla}</Value>
      <Span>Número de Afiliado:</Span>
      <Value>{props.patient.nroAfiliado}</Value>
    </Details>
    <Formik
      initialValues={{
        phone: props.patient.telefono,
        email: props.auth.mail
      }}
      validationSchema={validations}
      onSubmit={props.onSubmit}
      render={renderProps => (
        <Form onSubmit={renderProps.handleSubmit}>
          <FormInputs>
            <InputField
              name="email"
              id="email"
              type="email"
              placeholder="Email *"
              warning={renderProps.errors.email && renderProps.touched.email}
            />
            <InputField
              name="phone"
              id="phone"
              type="phone"
              placeholder="Teléfono *"
              warning={renderProps.errors.phone && renderProps.touched.phone}
            />
          </FormInputs>

          <ButtonsContainer>
            <SecondButton
              onClick={e => {
                e.preventDefault()
                props.onCancel()
              }}
            >
              Volver
            </SecondButton>
            <Button type="submit">Confirmar</Button>
          </ButtonsContainer>
        </Form>
      )}
    />
  </Container>
)

FormConfirmAppointment.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
}

function mapStateToProps({ auth }) {
  return { auth }
}
export default connect(
  mapStateToProps,
  null
)(FormConfirmAppointment)

/*
 * Styles
 */

const Container = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
`

const Form = styled.form`
  width: 100%;
`

const Title = styled(Paragraph)`
  margin: 30px 0;
  font-weight: 600;
  font-size: 24px;
  color: ${props => props.theme.colors.green};
  text-align: center;
  @media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
    margin: 20px 0;
  }
`
const Details = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px 40px;
  width: 100%;
  font-size: 14px;
  @media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
    font-size: 13px;
    grid-gap: 13px 3px;
  }
`
const Span = styled.span`
  justify-self: end;
  color: ${props => props.theme.colors.warmGreyTwo};
`
const Value = styled.span`
  color: ${props => props.theme.colors.green};
  font-weight: bold;
`

const ButtonsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 39px;
  margin-top: 30px;
  @media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
    grid-template-columns: 1fr;
    grid-gap: 12px;
  }
`

const SecondButton = styled(Button)`
  @media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
    grid-row: 2;
  }
`

const FormInputs = styled.div`
  width: 520px;
  margin: 32px auto 0 auto;
  > div {
    margin: 10px 0;
  }
  @media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
    width: 100%;
  }
`
